import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal addphasemodal-wrap" }
const _hoisted_2 = {
  class: "modal fade",
  id: "addPhaseModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable m-auto" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  key: 0,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_7 = {
  key: 1,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_8 = {
  key: 2,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = { class: "form-wrap pt-0" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_14 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "exampleInputEmail1" }
const _hoisted_17 = { class: "light-blue-bg rounded border p-3 mb-3" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = {
  key: 0,
  class: "bg-white task-list-wrap mb-2 border rounded p-2"
}
const _hoisted_20 = { class: "righ-actions" }
const _hoisted_21 = { class: "right-position" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { for: "" }
const _hoisted_27 = {
  key: 0,
  class: "required"
}
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { for: "" }
const _hoisted_31 = { class: "col-md-5" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { for: "" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "dropdown-wrap unit-dropdown position-relative items-dropdown w-100 choose-item-dropdown" }
const _hoisted_36 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_38 = {
  key: 1,
  ref: "table"
}
const _hoisted_39 = { class: "text-right p-3" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "text-success mt-1"
}
const _hoisted_42 = { class: "list-accordion mt-2" }
const _hoisted_43 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_44 = { class: "card border p-0 shadow-sm" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "card-body p-2" }
const _hoisted_47 = { class: "table-responsive font-12" }
const _hoisted_48 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_49 = { class: "table-primary nowrap-text" }
const _hoisted_50 = { scope: "col" }
const _hoisted_51 = { scope: "col" }
const _hoisted_52 = { scope: "col" }
const _hoisted_53 = { scope: "col" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { for: "taskTimeline" }, "Task Timeline", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Day", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Week", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Month", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("option", { value: "4" }, "To Be Decided Later", -1)
const _hoisted_62 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { for: "numberInput" }
const _hoisted_65 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_66 = { class: "form-check mt-4" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "excludeWeekends"
}, " Exclude Weekends ", -1)
const _hoisted_68 = {
  key: 1,
  class: "form-group"
}
const _hoisted_69 = { class: "dropdown-wrap unit-dropdown position-relative items-dropdown w-100 choose-item-dropdown" }
const _hoisted_70 = { class: "dropdown-menu table-dropdown items-dropdown-menu" }
const _hoisted_71 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_73 = { ref: "table" }
const _hoisted_74 = { class: "text-right p-3" }
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_76 = { key: 2 }
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_78 = { class: "row mx-n2" }
const _hoisted_79 = { class: "col-md-4 px-2" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = { for: "exampleInputEmail1" }
const _hoisted_82 = { class: "text-success mt-1" }
const _hoisted_83 = { class: "col-md-4 px-2" }
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("No. of days for this phase: ")
const _hoisted_86 = { class: "col-md-3 px-2" }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { for: "projectDate" }, "Phase Timeline", -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("option", { value: "4" }, "To Be Decided Later", -1)
const _hoisted_90 = { value: "5" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = { for: "" }
const _hoisted_93 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_94 = { class: "row mx-n2" }
const _hoisted_95 = {
  key: 0,
  class: "shadowed-card bg-white mb-2 mr-2"
}
const _hoisted_96 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_97 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_98 = { class: "sr-only" }
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_100 = { class: "imaged-col" }
const _hoisted_101 = { class: "small-img-wrap" }
const _hoisted_102 = { class: "size" }
const _hoisted_103 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_104 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_105 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_106 = { class: "sr-only" }
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_108 = { class: "imaged-col" }
const _hoisted_109 = { class: "small-img-wrap" }
const _hoisted_110 = { class: "size" }
const _hoisted_111 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_112 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_113 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_114 = { class: "sr-only" }
const _hoisted_115 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_116 = { class: "imaged-col" }
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_118 = { class: "size" }
const _hoisted_119 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_120 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_121 = { class: "centered-wrap" }
const _hoisted_122 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_123 = { class: "sr-only" }
const _hoisted_124 = { class: "size" }
const _hoisted_125 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_126 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_127 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMemberCustomValidity",
  tabindex: "-1",
  "aria-labelledby": "inviteMemberCustomValidity",
  "aria-hidden": "true"
}
const _hoisted_128 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_129 = { class: "modal-content" }
const _hoisted_130 = { class: "modal-header" }
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  })
], -1)
const _hoisted_132 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_133 = { class: "modal-body" }
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { class: "col-md-6" }
const _hoisted_136 = { class: "form-group" }
const _hoisted_137 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Initial Date", -1)
const _hoisted_138 = { class: "col-md-6" }
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Final Date", -1)
const _hoisted_141 = { class: "modal-footer" }
const _hoisted_142 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.editMode && _ctx.editFrom == 'phase')
              ? (_openBlock(), _createBlock("h5", _hoisted_6, _toDisplayString(_ctx.$t('edit_phase')), 1))
              : (_ctx.editMode && _ctx.editFrom == 'task')
                ? (_openBlock(), _createBlock("h5", _hoisted_7, _toDisplayString(_ctx.$t('edit_task')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_8, _toDisplayString(_ctx.$t('add_phase')), 1)),
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedPhase && _ctx.resetSelectedPhase(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.createPhase,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                (!_ctx.editMode && !_ctx.phase)
                  ? (_openBlock(), _createBlock("label", _hoisted_13, _toDisplayString(_ctx.$t('phase_name')), 1))
                  : (_openBlock(), _createBlock("label", _hoisted_14, _toDisplayString(_ctx.$t('name')), 1)),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.phase.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.phase.name]
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('phase_description')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control h-auto",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.phase.description = $event)),
                  rows: "8"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.phase.description]
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("h6", _hoisted_18, _toDisplayString(_ctx.$t('task_lists')), 1),
                (_ctx.state.data.phase.groupTasks.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phase.groupTasks, (task, taskIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "task-card rounded border p-3 mb-2",
                          key: taskIndex
                        }, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("div", _hoisted_21, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "btn btn-sm red-btn",
                                title: "delete",
                                onClick: ($event: any) => (_ctx.deleteGroupItem(task))
                              }, [
                                _hoisted_22
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_23, [
                              _createVNode("div", _hoisted_24, [
                                _createVNode("div", _hoisted_25, [
                                  _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('task_name')), 1),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: task.nameError
                              ? 'form-control error-field'
                              : 'form-control'
                              ,
                                    "onUpdate:modelValue": ($event: any) => (task.name = $event),
                                    disabled: task.isDisable,
                                    required: ""
                                  }, null, 10, ["onUpdate:modelValue", "disabled"]), [
                                    [_vModelText, task.name]
                                  ]),
                                  (task.nameError)
                                    ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('task_name_required')), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode("div", _hoisted_28, [
                                _createVNode("div", _hoisted_29, [
                                  _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('task_price')), 1),
                                  _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(task.budget, null)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_31, [
                                _createVNode("div", _hoisted_32, [
                                  _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('task_details')), 1),
                                  _withDirectives(_createVNode("textarea", {
                                    class: "form-control h-auto",
                                    rows: 5,
                                    "onUpdate:modelValue": ($event: any) => (task.description = $event),
                                    disabled: task.isDisable
                                  }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                                    [_vModelText, task.description]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_34, [
                            _createVNode("div", _hoisted_35, [
                              _createVNode("a", {
                                class: "dropdown-toggle d-block border rounded py-2 px-3 bg-white",
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: ($event: any) => (_ctx.editGroupTask(task.items, taskIndex))
                              }, _toDisplayString(_ctx.$t('update_item')), 9, ["onClick"]),
                              _createVNode("div", {
                                class: "dropdown-menu table-dropdown items-dropdown-menu",
                                onClick: ($event: any) => (_ctx.editGroupTask(task.items, taskIndex))
                              }, [
                                (_ctx.state.ui.isLoading.getData)
                                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                                      _hoisted_37
                                    ]))
                                  : _createCommentVNode("", true),
                                (task.tableSelected)
                                  ? (_openBlock(), _createBlock("div", _hoisted_38, null, 512))
                                  : _createCommentVNode("", true),
                                _createVNode("div", _hoisted_39, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn",
                                    onClick: ($event: any) => (_ctx.updateSelectItem(task.items, taskIndex))
                                  }, [
                                    _hoisted_40,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                                  ], 8, ["onClick"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn secondary-btn",
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeSelected && _ctx.closeSelected(...args)))
                                  }, _toDisplayString(_ctx.$t('close')), 1)
                                ])
                              ], 8, ["onClick"]),
                              (task.estimation_items)
                                ? (_openBlock(), _createBlock("p", _hoisted_41, _toDisplayString(task.estimation_items.length) + " " + _toDisplayString(_ctx.$t('item_selected')), 1))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_42, [
                                _createVNode("div", _hoisted_43, [
                                  _createVNode("div", _hoisted_44, [
                                    _createVNode("div", {
                                      class: "card-header p-0",
                                      id: `heading00${taskIndex}`
                                    }, [
                                      _createVNode("h2", _hoisted_45, [
                                        (task.items)
                                          ? (_openBlock(), _createBlock("button", {
                                              key: 0,
                                              class: "btn btn-link text-left shadow-none collapsed",
                                              type: "button",
                                              "data-toggle": "collapse",
                                              "data-target": `#collapse00${taskIndex}`,
                                              "aria-expanded": "true",
                                              "aria-controls": "collapseOne",
                                              fdprocessedid: "lut3nd"
                                            }, _toDisplayString(task.items.length) + " " + _toDisplayString(_ctx.$t('item_selected')), 9, ["data-target"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, ["id"]),
                                    _createVNode("div", {
                                      id: `collapse00${taskIndex}`,
                                      class: "collapse",
                                      "aria-labelledby": "headingOne",
                                      "data-parent": "#accordionExample"
                                    }, [
                                      _createVNode("div", _hoisted_46, [
                                        _createVNode("div", _hoisted_47, [
                                          _createVNode("table", _hoisted_48, [
                                            _createVNode("thead", _hoisted_49, [
                                              _createVNode("tr", null, [
                                                _createVNode("th", _hoisted_50, _toDisplayString(_ctx.$t('name')), 1),
                                                _createVNode("th", _hoisted_51, _toDisplayString(_ctx.$t('description')), 1),
                                                _createVNode("th", _hoisted_52, _toDisplayString(_ctx.$t('cost')), 1),
                                                _createVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('quantity')), 1)
                                              ])
                                            ]),
                                            _createVNode("tbody", null, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.items, (item, itemIndex) => {
                                                return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                                                  _createVNode("td", null, _toDisplayString(item.name), 1),
                                                  _createVNode("td", null, _toDisplayString(item.description), 1),
                                                  _createVNode("td", null, _toDisplayString(_ctx.usdPriceFormate(item.cost, null)), 1),
                                                  _createVNode("td", null, _toDisplayString(item.quantity), 1)
                                                ]))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ], 8, ["id"])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_54, [
                            _createVNode("div", _hoisted_55, [
                              _createVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _withDirectives(_createVNode("select", {
                                  id: "taskTimeline",
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => (task.taskTimeline.type = $event)
                                }, [
                                  _hoisted_58,
                                  _hoisted_59,
                                  _hoisted_60,
                                  _hoisted_61
                                ], 8, ["onUpdate:modelValue"]), [
                                  [_vModelSelect, task.taskTimeline.type]
                                ])
                              ])
                            ]),
                            (['1', '2', '3'].includes(task.taskTimeline.type))
                              ? (_openBlock(), _createBlock("div", _hoisted_62, [
                                  _createVNode("div", _hoisted_63, [
                                    _createVNode("label", _hoisted_64, _toDisplayString(_ctx.getNumberLabel(task.taskTimeline.type)), 1),
                                    _withDirectives(_createVNode("input", {
                                      type: "number",
                                      id: "numberInput",
                                      class: "form-control",
                                      "onUpdate:modelValue": ($event: any) => (task.taskTimeline.value = $event),
                                      placeholder: "Enter number"
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, task.taskTimeline.value]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (['2', '3'].includes(task.taskTimeline.type))
                              ? (_openBlock(), _createBlock("div", _hoisted_65, [
                                  _createVNode("div", _hoisted_66, [
                                    _createVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "excludeWeekends",
                                      checked: task.taskTimeline.excludeWeekends === 1,
                                      onChange: ($event: any) => (task.taskTimeline.excludeWeekends = $event.target.checked ? 1 : 0)
                                    }, null, 40, ["checked", "onChange"]),
                                    _hoisted_67
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editFrom != 'task' && _ctx.state.showSelectedItem)
                  ? (_openBlock(), _createBlock("div", _hoisted_68, [
                      _createVNode("div", _hoisted_69, [
                        _createVNode("a", {
                          class: "dropdown-toggle  bg-white d-block border rounded py-2 px-3",
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onToggleChooseItem()))
                        }, _toDisplayString(_ctx.$t('choose_item')), 1),
                        _createVNode("div", _hoisted_70, [
                          (_ctx.state.ui.isLoading.getData)
                            ? (_openBlock(), _createBlock("div", _hoisted_71, [
                                _hoisted_72
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_73, null, 512),
                          _createVNode("div", _hoisted_74, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn default-btn",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateSelected && _ctx.updateSelected(...args)))
                            }, [
                              _hoisted_75,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('done')), 1)
                            ]),
                            _createVNode("button", {
                              type: "button",
                              class: "btn secondary-btn",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeSelected && _ctx.closeSelected(...args)))
                            }, _toDisplayString(_ctx.$t('close')), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.showGroupItemButton && (_ctx.state.data.phase.groupTasks && _ctx.state.data.phase.groupTasks.length))
                  ? (_openBlock(), _createBlock("div", _hoisted_76, [
                      _createVNode("button", {
                        class: "btn default-btn",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addGroupTask && _ctx.addGroupTask(...args)))
                      }, [
                        _hoisted_77,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add_more_tasks')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_78, [
                _createVNode("div", _hoisted_79, [
                  _createVNode("div", _hoisted_80, [
                    _createVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('phase_estimate_budget')), 1),
                    _createVNode("p", _hoisted_82, _toDisplayString(_ctx.usdPriceFormate(_ctx.total, null)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, [
                    _createVNode("p", null, [
                      _hoisted_85,
                      _createVNode("strong", null, _toDisplayString(_ctx.totalPhaseDays), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_86, [
                  _createVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _withDirectives(_createVNode("select", {
                      id: "projectDate",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.phase.phaseTimeline.type = $event)),
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDateTypeChange && _ctx.handleDateTypeChange(...args)))
                    }, [
                      _hoisted_89,
                      _createVNode("option", _hoisted_90, _toDisplayString(_ctx.state.data.phase.phaseTimeline.startDate &&
                        _ctx.state.data.phase.phaseTimeline.endDate ?
                        `${_ctx.state.data.phase.phaseTimeline.startDate} -
                        ${_ctx.state.data.phase.phaseTimeline.endDate}` : 'Custom Date'), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.state.data.phase.phaseTimeline.type]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_91, [
                _createVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('upload_attachment')), 1),
                (_ctx.state.data.phase.attachments &&
                  _ctx.state.data.phase.attachments.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_93, [
                      _createVNode("div", _hoisted_94, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phase
                      .attachments, (image, imageIndex) => {
                          return (_openBlock(), _createBlock("div", { key: imageIndex }, [
                            (image.extension === 'jpg' ||
                        image.extension === 'png' ||
                        image.extension === 'jpeg' ||
                        image.extension === 'gif'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_95, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_96, [
                                        _createVNode("span", _hoisted_97, [
                                          _createVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_99
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_100, [
                                    _createVNode("div", _hoisted_101, [
                                      _createVNode("img", {
                                        src: image.file,
                                        alt: image.name,
                                        height: "200"
                                      }, null, 8, ["src", "alt"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                    _createVNode("p", _hoisted_102, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'pdf')
                              ? (_openBlock(), _createBlock("div", _hoisted_103, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_104, [
                                        _createVNode("span", _hoisted_105, [
                                          _createVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_107
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_108, [
                                    _createVNode("div", _hoisted_109, [
                                      _createVNode("img", {
                                        src: _ctx.state.data.imageBaseUrl
                              ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                              : 'img/pdf.jpg'
                              ,
                                        alt: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                    _createVNode("p", _hoisted_110, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'doc' ||
                        image.extension === 'docx'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_111, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_112, [
                                        _createVNode("span", _hoisted_113, [
                                          _createVNode("span", _hoisted_114, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_115
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_116, [
                                    _hoisted_117,
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_118, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'mp4' ||
                        image.extension === 'mov' ||
                        image.extension === 'MOV' ||
                        image.extension === 'wmv' ||
                        image.extension === 'webm' ||
                        image.extension === 'ogg' ||
                        image.extension === 'avi' ||
                        image.extension === 'x-ms-wmv'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_119, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_120, [
                                        _createVNode("div", _hoisted_121, [
                                          _createVNode("span", _hoisted_122, [
                                            _createVNode("span", _hoisted_123, _toDisplayString(_ctx.$t('loading1')), 1)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                          : 'img/video-icon.png'
                          ,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"]),
                                  _createVNode("h5", null, _toDisplayString(image.name), 1),
                                  _createVNode("p", _hoisted_124, _toDisplayString(image.size), 1),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_125
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_DragAndDropZone, {
                  onDrop: _withModifiers(_ctx.dropPhaseFiles, ["prevent"]),
                  onDropFiles: _ctx.dropPhaseFiles
                }, null, 8, ["onDrop", "onDropFiles"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_126, [
            _createVNode("div", _hoisted_127, [
              _createVNode("div", _hoisted_128, [
                _createVNode("div", _hoisted_129, [
                  _createVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_132
                    ])
                  ]),
                  _createVNode("div", _hoisted_133, [
                    _createVNode("div", _hoisted_134, [
                      _createVNode("div", _hoisted_135, [
                        _createVNode("div", _hoisted_136, [
                          _hoisted_137,
                          _createVNode(_component_v_date_picker, {
                            id: "startDate",
                            modelValue: _ctx.customStartDate,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.customStartDate = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_138, [
                        _createVNode("div", _hoisted_139, [
                          _hoisted_140,
                          _createVNode(_component_v_date_picker, {
                            id: "endDate",
                            modelValue: _ctx.customEndDate,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.customEndDate = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_141, [
                    _createVNode("div", null, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn mr-2",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveCustomDaysToselectedMember && _ctx.saveCustomDaysToselectedMember(...args)))
                      }, _toDisplayString(_ctx.$t('save')), 1),
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn secondary-btn mr-2",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args)))
                      }, _toDisplayString(_ctx.$t('cancel')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_142, [
            (_ctx.$props.editData)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  buttonName: _ctx.state.data.buttonName,
                  buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
                  onButtonTrigger: _ctx.createPhase,
                  disabled: !_ctx.isPhaseValid
                }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger", "disabled"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  buttonName: _ctx.state.data.buttonName,
                  buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
                  onButtonTrigger: _ctx.createPhase,
                  disabled: !_ctx.isPhaseValid
                }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger", "disabled"])),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedPhase && _ctx.resetSelectedPhase(...args)))
            }, _toDisplayString(_ctx.$t('close')), 1)
          ])
        ])
      ])
    ])
  ]))
}